import React from 'react'

import HongKongPlatform from './HongKongPlatform.js'
import SydneyPlatform from './SydneyPlatform.js'
import DubaiPlatform from './DubaiPlatform.js'

import '../../../styles/HomePageStyles/PlatformStyles/independentplatform.css'

export default class IndependentPlatform extends React.Component{
    render(){
        return(
            <div className="ip__container">
                <div className="ip__sydney">
                    <SydneyPlatform/>
                </div>
                <div className="ip__hong-kong">
                    <HongKongPlatform/>
                </div>
                <div className="ip__dubai">
                    <DubaiPlatform/>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/HomePage/Platforms/IndependentPlatform.js